
<div class="">
  <button
    id="addLabelFilter"
    type="button"
    class="mr-2 d-flex justify-content-between align-items-center"
    :style="{
      color: '#888',
      padding: '3px 5px',
      'border-radius': '3px',
      'font-size': '.9rem',
      border: 'dashed 1px #888',
    }"
  >
    <i class="far fa-plus mr-1 ml-1"></i>
    Add Label
  </button>

  <b-popover target="addLabelFilter" ref="addLabelFilter" triggers="click blur">
    <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center">Add Label</div>
    <hr class="mt-2 mb-2" />
    <input type="text" v-model="filter" class="form-control mb-2 mt-1" placeholder="Filter..." />

    <div class="bi-label-container">
      <div v-for="label in filteredLabels" :key="label.id">
        <div
          class="bi-label mb-2 cursor-pointer"
          :style="{
            'background-color': label.color,
          }"
          @click="addLabel(label)"
        >
          <i v-if="label.icon" :class="label.icon" class="mr-1 ml-1"></i>
          {{ label.title }}
        </div>
      </div>

      <div v-if="!filteredLabels.length">
        <div class="bi-label no-available-labels mb-2">No labels available</div>
      </div>
    </div>
  </b-popover>
</div>
